module.exports = __webpack_public_path__ + "static/media/sapbusiness.29c968da.svg";